// handle table of content article
function initToc($toc) {
  if ($toc.hasClass('initialized')) { return; }
  $toc.addClass('initialized');
  const article_content = document.getElementById("js-article-detail")
  const list_h2 = article_content.getElementsByTagName("h2")
  const title_number = list_h2.length
  for (let i = 0; i < title_number; i++) {
    list_h2[i].setAttribute("id", i)
  }

  const table_of_content = $toc[0]
  for (let i = 0; i < title_number; i++) {
    const li_element = document.createElement("li");
    li_element.innerHTML = `<a href=#${i}>${list_h2[i].innerHTML}</a>`
    table_of_content.appendChild(li_element)
  }

  $toc.find('a').attr('data-turbolinks', false);
  $toc.find('a').click(function (e) {
    e.preventDefault();
    var toc_psy_id = $(this).attr('href').substring(1);
    var $toc_psy_pane = $(document.getElementById(toc_psy_id));
    if ($toc_psy_pane.length > 0) {
      $('html, body').animate({
        scrollTop: $toc_psy_pane.offset().top - 100
      }, 300);
    }
  });
}

$(document).ready(function () {
  if ($('.js-article-toc').length === 1) {
    initToc($('.js-article-toc'));
  }
})
